frontApp.reviews = {
  init() {
    this.reviewGalleryInit();
    this.reviewVotingInit();
  },
  reviewGalleryInit() {
    const $reviewGallery = $('.js-review-gallery');
    if (!$reviewGallery.length) {
      return;
    }

    Fancybox.bind('.js-review-gallery a', {
      mainClass: 'image-zoom-theme',
      infinite: false,
      Toolbar: {
        display: [
          'zoom',
          'close',
        ],
      },
    });
  },
  reviewVotingInit() {
    const $votingBtn = $('.js-voting-btn').not('.initialized');
    if ($votingBtn.length) {
      this.reviewVoting($votingBtn);
    }
  },
  reviewVoting(el) {
    const changeCounter = ($el, num) => {
      $el.html(num).attr('data-count', num);
    };

    el.on('click', function (e) {
      e.preventDefault();
      const $curBtn = $(this);
      const $counter = $curBtn.find('.js-voting-count');
      const count = +$counter.attr('data-count');
      if ($curBtn.hasClass('is-active')) {
        $curBtn.removeClass('is-active');
        changeCounter($counter, count - 1);
      } else {
        $curBtn.addClass('is-active');
        changeCounter($counter, count + 1);
        const $siblingActive = $curBtn.siblings('.is-active');
        if ($siblingActive.length) {
          $siblingActive.removeClass('is-active');
          const $siblingsCounter = $siblingActive.find('.js-voting-count');
          changeCounter($siblingsCounter, +$siblingsCounter.attr('data-count') - 1);
        }
      }
    });
  },
};
